/**
 * NotificationContainer - Updated Component
 *
 * This component now uses the design system Alert component
 * for improved accessibility and consistency.
 */

import React from 'react';
import { useApp } from '../../context/AppContext';
import { Alert } from '../../design-system';

const NotificationContainer = () => {
  const { notifications, removeNotification } = useApp();

  if (notifications.length === 0) return null;

  // Map notification types to Alert variants
  const getAlertVariant = (type) => {
    const variantMap = {
      success: 'success',
      error: 'danger',
      warning: 'warning',
      info: 'info',
    };
    return variantMap[type] || 'info';
  };

  return (
    <div className="fixed top-4 right-4 z-50 space-y-2 max-w-sm w-full">
      {notifications.map((notification) => (
        <div
          key={notification.id}
          className="animate-slide-in-right"
        >
          <Alert
            variant={getAlertVariant(notification.type)}
            title={notification.title}
            dismissible={true}
            onDismiss={() => removeNotification(notification.id)}
            className="shadow-lg"
          >
            {notification.message}
          </Alert>
        </div>
      ))}
    </div>
  );
};

export default NotificationContainer;